import * as React from 'react';
import { getBreadcrumbs } from '../../selectors/seo/getBreadcrumbs';
import { useSelector } from 'react-redux';
import { Breadcrumbs } from '../../components/Breadcrumbs';

export const BreadcrumbsContainer = () => {
  const breadcrumbs = useSelector(getBreadcrumbs);

  return <Breadcrumbs stack={breadcrumbs} />;
};
